export const maskEmail = (email: string) => {
  const parts = email.split("@")
  if (parts.length !== 2) return ""
  return `xxx@${parts[1]}`
}

export const createHash = async (value: string) => {
  const encoder = new TextEncoder()
  const data = encoder.encode(value)

  const hashBuffer = await crypto.subtle.digest("SHA-1", data)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, "0")).join("")
  return hashHex
}
